import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import Collapsible from 'react-collapsible';
const $=window.$;
const win=window;
const jQuery=window.jQuery;

class NotepadPopup extends Component {
    constructor(props) {
        super(props);
        this.selector="notespopup";
        this.state={
            room_name:"",
            name:"",
            learner:[],
            notes:[]
        };

    }

    popup_close(){      
       
        jQuery('.sa-icon').css( "display", "none" );
        jQuery('#'+this.selector).css( "display", "none" );
        jQuery('.modal-overlay').css( "display", "none" );             
          
    }

   minimize(){

    jQuery('#'+this.selector).css({
        height:'30px',
        width:'300px',
        overflow:'hidden',
        transform:'rotate(360deg)',
        '-webkit-transform':'rotate(360deg)',
        '-moz-transform':'rotate(360deg)',
        '-o-transform':'rotate(360deg)',
        position:'fixed', 
        transition:' all ease .4s',
        '-webkit-transition': 'all ease .4s',
        '-moz-transition': 'all ease .4s',
        '-o-transition': 'all ease .4s'

    });
	
   }

   maximize(){

    jQuery('#'+this.selector).css({
        top:'20px',
        display: 'block',
        left:'25%',
        height:'auto',
        width:'56%',
        overflow:'unset',
        transform:'unset',
        '-webkit-transform':'unset',
        '-moz-transform':'unset',
        '-o-transform':'unset',
        position:'absolute'

    });



    // jQuery('#notespopup').show();
   }


   openPopup(data,room_name,name,learner){
    let self=this;
     
  
        

           
      

   }

    componentDidMount () {

        const {data,room_name,name,learner}=this.props;

        let appendthis =  ("<div class='modal-overlay js-modal-close'></div>");
      
            jQuery("body").append(appendthis);
            jQuery(".modal-overlay").fadeTo(500, 0.7);
            //$(".js-modalbox").fadeIn(500);
            let modalBox = jQuery('#'+this.selector).attr('data-modal-id');
            jQuery('#'+this.selector).fadeIn(jQuery('#'+this.selector).data());

        jQuery(".js-modal-close, .modal-overlay").click(function() {
            jQuery(".modal-box, .modal-overlay").fadeOut(500, function() {
                jQuery(".modal-overlay").remove();
            
            });
            });
    
            jQuery(window).resize(function() {
            jQuery(".modal-box").css({
                top: 20,//(jQuery(window).height() - jQuery(".modal-box").outerHeight()) / 2,
                left: (jQuery(window).width() - jQuery(".modal-box").outerWidth()) / 2
            });
            });
            
            jQuery(window).resize();

            setTimeout(()=>{

                this.setState({
                    room_name:room_name,
                    name:name,
                    learner:learner,
                    notes:data
                });
            },150);

       

    }

    render () {

        
        let learner=this.state.learner;
        let notesdata=this.state.notes;
            
        return (
            <div id={this.selector} style={{top: '20px',left: '297px',display: 'none'}} className="modal-box popup-ecoach">
                <div className="buttons-bar">
                    <a href="javascript:void(0);" onClick={(e)=>this.popup_close()} title="Close"><img src={process.env.PUBLIC_URL+'/images/cloze.png'}/></a>
                    <a href="javascript:void(0);" onClick={(e)=>this.minimize()} title="Minimize" className="" style={{marginRight: "35px"}}><img src="images/min.png"/></a>
                    <a href="javascript:void(0);" onClick={(e)=>this.maximize()} title="Maximize"><img src={process.env.PUBLIC_URL+'/images/max.png'}/></a>
                </div>
                <h2 className="write-pad-tiltle"><img src={process.env.PUBLIC_URL+'/images/wiriting-pad-icon.png'} border="0"/> All Notes</h2>
                <div className="modal-body popup-grey">
                <div className="writing-pad-outer">
                <div className="writing-pad-top">
                <div className="pad-left" style={{width: '100%'}}>
                <h2 className="cat_head_rgt">
            		<div id="learning_room_title" >
                    {learner}
                    </div>
            	</h2> 
                <h2 className="cat_head_rgt" style={{fontSize:'12px'}}>
            		<div id="learning_room_title" >
                    {this.state.room_name} 
                    </div>
            	</h2>   
                
                {notesdata!=undefined &&
                        <section className="overview">

                      
                    {notesdata!=null && 
                        <div>                           
                        {notesdata.map((key,i)=>
                         <Collapsible key={`notes_${i}`}  trigger={key.notes_title}>
                                   
                            <div><div dangerouslySetInnerHTML={{__html: key.notes}} /> </div>        
                       
                                  
                     </Collapsible> 
                    )}       
                    </div>
                        }
                     </section>
                     } 



                </div>               


            

            </div>           
            </div>
            </div>
          
            </div>
        )
    }
}

export default NotepadPopup


// WEBPACK FOOTER //
// ./src/lr_dlr_components/notepad_partials/NotepadPopup.js